Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.SummaryView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']

  initialize: (@options = {}, @header) ->
    # just set @options

  sections: -> #Esto no se usa para nada, o si?
    list = []
    list.push(new Monitoring.Reports.Publications.Summary.UsersView(@options))
    list.push(new Monitoring.Reports.Publications.Content.AnalyticsView(@options))
    list

  render_twitter:->
    @$el.html(@template(@options))
    summary_div = $('<div/>').addClass('content-item').attr('id', 'summary')

    users_view = new Monitoring.Reports.Publications.Summary.UsersView(@options)
    @analytics = analytics_view = new Monitoring.Reports.Publications.Content.AnalyticsView(@options)

    @sections_count = 1
    @sections_rendered = 0
    analytics_view.bind('rendered', @rendered).bind('fail', @fail)

    users_view.render_twitter()
    analytics_view.render_twitter()

    users_section = users_view.el
    analysis_section = $('<div/>').addClass('content-section content-analysis')

    details_subsection = "" # details_view.el # TODO
    metrics_subsection = $('<div/>').addClass('content-section content-metrics')
    analysis_section.append(details_subsection).append(metrics_subsection)

    analytics_subsection = analytics_view.el
    metrics_subsection.append(analytics_subsection)

    summary_div.append(users_section)
    summary_div.append(analysis_section)

    @$('.container').append(summary_div)



  render: ->
    @$el.html(@template(@options))
    summary_div = $('<div/>').addClass('content-item').attr('id', 'summary')

    users_view = new Monitoring.Reports.Publications.Summary.UsersView(@options)
    @analytics = analytics_view = new Monitoring.Reports.Publications.Content.AnalyticsView(@options)

    @sections_count = 1
    @sections_rendered = 0
    analytics_view.bind('rendered', @rendered).bind('fail', @fail)

    users_view.render()
    analytics_view.render()

    users_section = users_view.el
    analysis_section = $('<div/>').addClass('content-section content-analysis')

    details_subsection = "" # details_view.el # TODO
    metrics_subsection = $('<div/>').addClass('content-section content-metrics')
    analysis_section.append(details_subsection).append(metrics_subsection)

    analytics_subsection = analytics_view.el
    metrics_subsection.append(analytics_subsection)

    summary_div.append(users_section)
    summary_div.append(analysis_section)

    @$('.container').append(summary_div)

  rendered: =>
    @sections_rendered += 1
    @$('.spinner').remove() if @sections_rendered >= @sections_count

  fail: =>
    # TODO generic template (with content_view)
    error_message = I18n.t("monitoring.dashboard.publications.error")
    @$('.spinner').replaceWith("<div class='error'><i class='fa fa-exclamation-triangle'></i> #{error_message}</div>")

  fill_analytics: (data) ->
    summary_data = data.summary
    delete summary_data.reach
    delete summary_data.organic_reach
    delete summary_data.viral_reach
    delete summary_data.paid_reach
    @analytics.fill_analytics(summary_data)

  fill_twitter_analytics: (data)->
    summary_data = data.summary
    @analytics.fill_twitter_analytics(summary_data)
